import { render } from "./ReturnData.vue?vue&type=template&id=84ebc738&scoped=true"
import script from "./ReturnData.vue?vue&type=script&lang=js"
export * from "./ReturnData.vue?vue&type=script&lang=js"

import "./ReturnData.vue?vue&type=style&index=0&id=84ebc738&scoped=true&lang=css"
import "./ReturnData.vue?vue&type=style&index=1&id=84ebc738&lang=less&scoped=true"

import exportComponent from "D:\\Kaung\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84ebc738"]])

export default __exports__